import React, { useState, useEffect, useRef } from "react";
import Header from "../common/layout/header";
import Footer from "../common/layout/footer";
import { BaseUrl } from "../common/config";
import Sidebar from "../common/sidebar";
import { http } from "../helper";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import moment from "moment";
import { useTranslation } from "react-i18next";

const AddPromotions = () => {
  const { t } = useTranslation();
  const [inputFieldtitle, setInputFieldtitle] = useState("");
  const [bannerDesktop, setBannerDesktop] = useState(null);
  const [bannerMobile, setBannerMobile] = useState(null);
  const [bannerDesktopPreview, setBannerDesktopPreview] = useState(null);
  const [bannerMobilePreview, setBannerMobilePreview] = useState(null);
  const [errormsg, setErrormsg] = useState({});
  const [errmessage, setErrMessage] = useState({});
  const [alertPopup, setAlertPopup] = useState(false);
  const [alertMessage, setAlertMessage] = useState([]);
  const [visibleAlert, setVisibleAlert] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isFeatured, setIsFeatured] = useState(false); // For featured checkbox
  const [status, setStatus] = useState("active");
  const [selectedCategory, setSelectedCategory] = useState("");
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  // New states for handling PDF files
  const [pdfFiles, setPdfFiles] = useState([]);
  const [pdfFilesPreview, setPdfFilesPreview] = useState([]);
  const pdfInputRef = useRef(null);
  const isUrlCategory = selectedCategory === "url";
  const [promoUrl, setPromoUrl] = useState("");
  const [urlTarget, setUrlTarget] = useState(""); // For URL target (self or new window)
  const [isMonthlyPromo, setIsMonthlyPromo] = useState(false); // For monthly promotions checkbox
  const [priceBandIds, setPriceBandIds] = useState([]);
  const [checkedBandState, setCheckedBandState] = useState([]);
  const [checkedBand, setCheckedBand] = useState([]);

  if (!sessionStorage.getItem("isLoggedIn")) {
    window.location.href = "/";
  }
  if (
    JSON.parse(sessionStorage.getItem("authData")) != "" &&
    !JSON.parse(
      sessionStorage.getItem("authData"),
    ).adminRole.permissions.includes("manage_promotions")
  ) {
    window.location.href = "/unauthorized";
  }

  useEffect(() => {
    let URL1 = `${BaseUrl}admin/getpricebandids`;
    http
      .get(URL1)
      .then((response) => {
        let responseData = response?.data?.data;
        const uniquePriceBandIds = responseData.filter(
          (item, index, self) =>
            index ===
            self.findIndex(
              (t) => t.accountPriceListId === item.accountPriceListId,
            ),
        );
        setPriceBandIds(uniquePriceBandIds);
        setCheckedBandState(new Array(uniquePriceBandIds.length).fill(false));
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  function cancelbtn(e) {
    e.preventDefault();
    window.location.href = "/promotions";
    return false;
  }

  const handleOnChangeBand = (position, e) => {
    const updatedCheckedState = checkedBandState.map((item, index) => {
      return index === position ? !item : item;
    });
    var updatedList = [...checkedBand];
    if (e.target.checked) {
      updatedList = [...checkedBand, e.target.value];
    } else {
      updatedList.splice(checkedBand.indexOf(e.target.value), 1);
    }
    setCheckedBand(updatedList);
    setCheckedBandState(updatedCheckedState);
  };

  const handleFromDateChange = (date) => {
    setFromDate(date);
    setErrormsg((prev) => ({ ...prev, fromDateErr: "" }));
  };

  const handleToDateChange = (date) => {
    if (date >= fromDate) {
      setToDate(date);
      setErrormsg({ ...errormsg, toDateErr: "" });
    } else {
      setErrormsg({ ...errormsg, toDateErr: "Invalid Date Range!" });
    }
  };

  const handleDateKeyDown = (e) => {
    // Allow only deletion keys (Delete, Backspace) and navigation keys
    const allowedKeys = [
      "Delete",
      "Backspace",
      "Tab",
      "Escape",
      "ArrowLeft",
      "ArrowRight",
      "ArrowUp",
      "ArrowDown",
    ];
    if (!allowedKeys.includes(e.key)) {
      e.preventDefault();
    }
  };

  const handleRadioChange = (event) => {
    const { value } = event.target;
    setSelectedCategory(value);
    setErrormsg((prev) => ({ ...prev, categoryErr: "" }));
    if (value === "url") {
      setUrlTarget(""); // Reset to default when switching to URL
    } else {
      setPromoUrl("");
    }
  };

  const formvalidation = () => {
    let newErrors = {};
    let isValid = true;
    if (!inputFieldtitle.trim()) {
      newErrors.inputFieldtitleerr = t("field_required_txt");
      isValid = false;
    }
    if (!selectedCategory) {
      newErrors.categoryErr = t("please_select_category_txt");
      isValid = false;
    }
    if (selectedCategory !== "url") {
      // Dates are now optional, but if one is provided, both must be provided
      if ((fromDate && !toDate) || (!fromDate && toDate)) {
        if (!fromDate) {
          newErrors.fromDateErr = t("select_both_from_to_dates_txt");
        }
        if (!toDate) {
          newErrors.toDateErr = t("select_both_from_to_dates_txt");
        }
        isValid = false;
      } else if (fromDate && toDate && toDate < fromDate) {
        newErrors.toDateErr = t("invalid_date_range_txt");
        isValid = false;
      }
    }
    // URL validation separate
    if (selectedCategory === "url") {
      if (!promoUrl.trim()) {
        newErrors.promoUrlErr = t("field_required_txt");
        isValid = false;
      } else if (!/^(https?:\/\/)/i.test(promoUrl.trim())) {
        newErrors.promoUrlErr = t("valid_url_required_txt");
        isValid = false;
      }
      if (!urlTarget) {
        newErrors.promoUrlTargetErr = t("field_required_txt");
        isValid = false;
      }
    }
    if (!bannerDesktop) {
      newErrors.desktopErr = t("field_required_txt");
      isValid = false;
    }
    if (!bannerMobile) {
      newErrors.mobileErr = t("field_required_txt");
      isValid = false;
    }
    setErrormsg(newErrors);
    return isValid;
  };

  const submitButton = (e) => {
    e.preventDefault();
    if (!formvalidation()) {
      return;
    }
    uploadFile();
  };

  const eventhandlechange = (e) => {
    const value = e.target.value || "";
    setInputFieldtitle(value);
    setErrormsg((prev) => ({
      ...prev,
      inputFieldtitleerr: value.trim() ? "" : prev.inputFieldtitleerr,
    }));
  };

  const handleFileUpload = (event, type) => {
    const file = event.target.files[0];
    if (!file) {
      return;
    }
    const allowedTypes = ["image/jpeg", "image/png", "image/jpg"];
    const fileType = file.type.toLowerCase();
    const fileSizeInBytes = file.size;
    const fileSizeInMB = (fileSizeInBytes / 1024 / 1024).toFixed(2);
    const maxSizeMB = 2;
    let errorMessage = "";
    if (!allowedTypes.includes(fileType)) {
      errorMessage = t("img_only_allowed_txt");
    } else if (fileSizeInMB > maxSizeMB) {
      errorMessage = t("2mb_txt");
    }
    setErrormsg((prev) => ({
      ...prev,
      [`${type}Err`]: errorMessage,
    }));
    if (errorMessage) {
      event.target.value = "";
      return;
    }
    setErrormsg((prev) => ({
      ...prev,
      [`${type}Err`]: "",
    }));
    if (type === "desktop") {
      setBannerDesktop(file);
      setBannerDesktopPreview(URL.createObjectURL(file));
    } else {
      setBannerMobile(file);
      setBannerMobilePreview(URL.createObjectURL(file));
    }
  };
  // New function to handle PDF file uploads
  const handlePdfUpload = (event) => {
    const files = Array.from(event.target.files);
    const maxSizeMB = 8;
    let errorMessage = "";
    const validFiles = [];
    // Iterate through the files and check the validation
    for (let file of files) {
      const fileType = file.type.toLowerCase();
      const fileSizeInMB = file.size / 1024 / 1024;
      if (fileType !== "application/pdf") {
        errorMessage = t("only_pdf_allowed_txt");
        break;
      }
      if (fileSizeInMB > maxSizeMB) {
        errorMessage = t("max_file_size_txt");
        break;
      }
      if (!pdfFiles.some((f) => f.name === file.name)) {
        validFiles.push(file);
      }
    }
    // Handle error if any
    if (errorMessage) {
      setErrormsg((prev) => ({ ...prev, pdfFilesErr: errorMessage }));
      event.target.value = "";
      return;
    }
    setErrormsg((prev) => ({ ...prev, pdfFilesErr: "" }));
    // Append the valid files to the state
    setPdfFiles((prevFiles) => [...prevFiles, ...validFiles]);
    // Reset file input after selection
    if (pdfInputRef.current) {
      pdfInputRef.current.value = "";
    }
  };

  const removePdf = (index) => {
    const updatedFiles = [...pdfFiles];
    updatedFiles.splice(index, 1);
    setPdfFiles(updatedFiles);
    // Clear input to allow re-selecting same file again
    if (pdfInputRef.current) {
      pdfInputRef.current.value = "";
    }
  };

  const uploadFile = async () => {
    setIsLoading(true);
    try {
      const formData = new FormData();
      formData.append("Title", inputFieldtitle.trim());
      formData.append("Category", selectedCategory);
      if (selectedCategory === "url") {
        formData.append("redirectUrl", promoUrl.trim());
        formData.append("urlTarget", urlTarget);
        formData.append(
          "fromDate",
          fromDate
            ? moment(fromDate).startOf("day").format("YYYY-MM-DD HH:mm:ss")
            : "",
        );
        formData.append(
          "toDate",
          toDate
            ? moment(toDate).endOf("day").format("YYYY-MM-DD HH:mm:ss")
            : "",
        );
        formData.append("InDownloads", isFeatured);
        formData.append("InMonthlyPromo", isMonthlyPromo);
      } else {
        formData.append(
          "fromDate",
          fromDate
            ? moment(fromDate).startOf("day").format("YYYY-MM-DD HH:mm:ss")
          : "",
        );
        formData.append(
          "toDate",
          toDate
           ? moment(toDate).endOf("day").format("YYYY-MM-DD HH:mm:ss")
           : "",
        );
        formData.append("InDownloads", isFeatured);
        formData.append("InMonthlyPromo", isMonthlyPromo);
      }
      formData.append("Status", status);
      formData.append("bannerImageDesktop", bannerDesktop);
      formData.append("bannerImageMobile", bannerMobile);
      formData.append(
        "createdBy",
        JSON.parse(sessionStorage.getItem("authData")).adminName,
      );
      formData.append("PriceBandTobeExcluded", checkedBand.toString());
      pdfFiles.forEach((file) => {
        formData.append("pdfFiles", file);
      });
      const response = await http.post(
        BaseUrl + "admin/addpromotions",
        formData,
      );
      if (response.data.success) {
        setIsLoading(false);
        setAlertPopup(true);
        setAlertMessage(t("promotion_added_success_msg"));
      }
    } catch (error) {
      setIsLoading(false);
      setAlertPopup(true);
      setAlertMessage(t("error_upload_img"));
      console.error("Error:", error);
    }
  };

  const popupClose = (event) => {
    setVisibleAlert(false);
  };

  return (
    <section className="dashboard-block">
      {alertPopup && (
        <div
          className="custom-alert-pop common_alert_popup"
          style={{ display: "block" }}
        >
          <div className="custom-alert-container">
            <div className="custom-alert-wrap">
              <div className="custom-alert-header">
                <h4>{t("alert_txt")}</h4>
              </div>
              <div className="custom-alert-body">
                <p>{alertMessage}</p>
                <div className="alert-buttons">
                  <a
                    onClick={(e) => cancelbtn(e)}
                    className="popup-alert-btn button"
                  >
                    {t("ok_txt")}
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      <Sidebar />
      <div className="dash-left">
        <Header />
        <section className="cart-block">
          <div className="container">
            <h1 className="checkout-title">{t("add_promotion_txt")}</h1>
            <div className="right-table-outer-wrap">
              {isLoading ? (
                <div className="loading-buffer"></div>
              ) : (
                <form
                  method="post"
                  className="addform editform promo-form freeproduct-fieldset"
                  onSubmit={submitButton}
                >
                  <div className="input-field col-2">
                    <label>{t("title_txt")}</label>
                    <input
                      type="text"
                      value={inputFieldtitle}
                      name="inputFieldtitle"
                      onChange={eventhandlechange}
                      className="form-control"
                      placeholder={t("title_txt")}
                    />
                    {errormsg.inputFieldtitleerr && (
                      <div className="error-msg">
                        {errormsg.inputFieldtitleerr}
                      </div>
                    )}
                  </div>
                  <div className="input-field col-1">
                    <label>{t("category_selection_txt")}</label>
                    <div className="edit-free-cat-chks">
                      {["pizza", "pasta", "desserts", "url"].map(
                        (category, index) => {
                          let displayCategory =
                            category === "pasta"
                              ? t("pasta_txt")
                              : category === "url"
                                ? t("url_txt")
                                : category.charAt(0).toUpperCase() +
                                  category.slice(1);
                          return (
                            <div className="check-box" key={index}>
                              <input
                                type="radio"
                                id={`freeCat${index}`}
                                name="category"
                                value={category}
                                checked={selectedCategory === category}
                                onChange={handleRadioChange}
                              />
                              <label htmlFor={`freeCat${index}`}>
                                {displayCategory}
                              </label>
                            </div>
                          );
                        },
                      )}
                    </div>
                    {errormsg.categoryErr && (
                      <div className="error-msg">{errormsg.categoryErr}</div>
                    )}
                  </div>
                  {isUrlCategory && (
                    <>
                      <div className="input-field col-2">
                        <label>{t("url_txt")}</label>
                        <input
                          type="text"
                          className="form-control"
                          placeholder={t("url_placeholder_txt")}
                          value={promoUrl}
                          onChange={(e) => {
                            setPromoUrl(e.target.value);
                            setErrormsg((prev) => ({
                              ...prev,
                              promoUrlErr: "",
                            }));
                          }}
                        />
                        {errormsg.promoUrlErr && (
                          <div className="error-msg">
                            {errormsg.promoUrlErr}
                          </div>
                        )}
                      </div>
                      <div className="input-field col-2">
                        <label>{t("target_txt")}</label>
                        <select
                          className="urlwindow"
                          value={urlTarget}
                          onChange={(e) => {
                            setUrlTarget(e.target.value);
                            setErrormsg((prev) => ({
                              ...prev,
                              promoUrlTargetErr: "",
                            }));
                          }}
                        >
                          <option value="">{t("select_txt")}</option>
                          <option value="_self">{t("same_window_txt")}</option>
                          <option value="_blank">{t("new_window_txt")}</option>
                        </select>
                        {errormsg.promoUrlTargetErr && (
                          <div className="error-msg">
                            {errormsg.promoUrlTargetErr}
                          </div>
                        )}
                      </div>
                    </>
                  )}
                  <div className="input-field col-1">
                    <label>{t("promo_banner_valid_period_txt")}</label>
                  </div>
                  <div className="input-field col-3">
                    <label className="lbl-blk">{t("from_date_txt")}</label>
                    <DatePicker
                      selected={fromDate}
                      onChange={handleFromDateChange}
                      minDate={new Date()}
                      placeholderText={t("select_date_txt")}
                      dateFormat="dd-MM-yyyy"
                      onKeyDown={handleDateKeyDown}
                      className="form-control"
                    />
                    {errormsg.fromDateErr && (
                      <div className="error-msg">{errormsg.fromDateErr}</div>
                    )}
                  </div>
                  <div className="input-field col-3">
                    <label className="lbl-blk">{t("to_date_txt")}</label>
                    <DatePicker
                      selected={toDate}
                      onChange={handleToDateChange}
                      minDate={new Date()}
                      placeholderText={t("select_date_txt")}
                      dateFormat="dd-MM-yyyy"
                      onKeyDown={handleDateKeyDown}
                      className="form-control"
                    />
                    {errormsg.toDateErr && (
                      <div className="error-msg">{errormsg.toDateErr}</div>
                    )}
                  </div>
                  <div className="notification-field-set-wrap">
                    <div className="notification-field-set promo-field-set">
                      <label>
                        {t("banner_image_txt")}{" "}
                        <span className="text-note">
                          {t("max_upolad_filesize_txt")}
                        </span>
                      </label>
                      <div className="input-field col-1">
                        <label>
                          {t("desktop_txt")}{" "}
                          <span className="text-note">
                            {t("image_required_size_txt")}
                          </span>
                        </label>
                        <div className="flex align-center gap-10">
                          <input
                            type="file"
                            id="desktop_banner"
                            accept="image/png, image/jpeg, image/jpg"
                            onChange={(e) => handleFileUpload(e, "desktop")}
                          />
                          <span className="text-note">
                            {t("png_only_allowed_txt")}
                            <br />
                            <br />
                          </span>
                          {bannerDesktopPreview && (
                            <img
                              src={bannerDesktopPreview}
                              alt={t("desktop_preview_txt")}
                              width="150"
                            />
                          )}
                        </div>
                        {errormsg.desktopErr && (
                          <div className="error-msg">{errormsg.desktopErr}</div>
                        )}
                      </div>
                      <div className="input-field col-1">
                        <label>
                          {t("mobile_txt")}{" "}
                          <span className="text-note">
                            {t("image_file_required_size_txt")}
                          </span>
                        </label>
                        <div className="flex align-center gap-10">
                          <input
                            type="file"
                            id="mobile_banner"
                            accept="image/png, image/jpeg, image/jpg"
                            onChange={(e) => handleFileUpload(e, "mobile")}
                          />
                          <span className="text-note">
                            {t("png_only_allowed_txt")}
                            <br />
                            <br />
                          </span>
                          {bannerMobilePreview && (
                            <img
                              src={bannerMobilePreview}
                              alt={t("mobile_preview_txt")}
                              width="150"
                            />
                          )}
                        </div>
                        {errormsg.mobileErr && (
                          <div className="error-msg">{errormsg.mobileErr}</div>
                        )}
                      </div>
                    </div>
                  </div>
                  {/* PDF File Upload */}
                  <div className="input-field col-1">
                    <label>
                      {t("pdf_for_download_txt")}{" "}
                      <span className="text-note">
                        {" "}
                        {t("max_upload_file_size8_txt")}
                      </span>
                    </label>
                    <div className="flex flex-column">
                      <div className="input-note-wrapper">
                        <input
                          type="file"
                          accept="application/pdf"
                          multiple
                          onChange={handlePdfUpload}
                          ref={pdfInputRef}
                        />
                        <span className="text-note">
                          {t("pdf_files_only_allowed_txt")}
                        </span>
                      </div>
                      {/* Show selected files below the "Choose File" input */}
                      <div className="pdf-preview-list">
                        {pdfFiles.length > 0 && (
                          <div className="pdf-chip-list">
                            {pdfFiles.map((file, index) => (
                              <div key={index} className="pdf-chip-item">
                                {file.name}
                                <span
                                  className="remove-pdf"
                                  onClick={() => removePdf(index)}
                                >
                                  X
                                </span>
                              </div>
                            ))}
                          </div>
                        )}
                        {/* Show "+" symbol for adding more files */}
                        {pdfFiles.length > 0 && (
                          <div className="add-more-files-section">
                            <span
                              className="add-more-files"
                              onClick={() => pdfInputRef.current.click()}
                            >
                              {t("add_more_file_txt")}
                            </span>
                          </div>
                        )}
                      </div>
                      {errormsg.pdfFilesErr && (
                        <div className="error-msg">{errormsg.pdfFilesErr}</div>
                      )}
                    </div>
                  </div>
                  {/* Featured Checkbox */}
                  <div className="input-field col-1">
                    <label htmlFor="downloads">{t("display_download_txt")}</label>{" "}
                    <span className="text-note font-sm">
                      {" "}
                      {t("date_range_for_promo_banner_valid_period_txt")}
                    </span>
                    <div className="check-box no-disable-chk">
                      <input
                        type="checkbox"
                        id="setImg"
                        className="check-box"
                        checked={isFeatured}
                        onChange={(e) => setIsFeatured(e.target.checked)}
                        disabled={!fromDate || !toDate}
                      />
                      <label htmlFor="setImg">{t("yes_txt")}</label>
                    </div>
                  </div>
                  {/* Monthly Promotions Checkbox */}
                  <div className="input-field col-1">
                    <label htmlFor="promotions">
                      {t("display_monthly_promotions_txt")}
                    </label>{" "}
                    <span className="text-note font-sm">
                      {" "}
                      {t("date_range_for_promo_banner_valid_period_txt")}
                    </span>
                    <div className="check-box no-disable-chk">
                      <input
                        type="checkbox"
                        id="monthlyPromo"
                        className="check-box"
                        checked={isMonthlyPromo}
                        onChange={(e) => setIsMonthlyPromo(e.target.checked)}
                        disabled={!fromDate || !toDate}
                      />
                      <label htmlFor="monthlyPromo">{t("yes_txt")}</label>
                    </div>
                  </div>
                  {/* Price Bands to be excluded */}
                  <div className="input-field">
                    <label>
                      {t("pricebands_tobe_exclude_txt")}
                    </label>
                    <br /> <br />
                    {priceBandIds.map((priceBand, index) => (
                      <div
                        className="check-box"
                        style={{ display: "inline-block", width: "200px" }}
                      >
                        <input
                          type="checkbox"
                          name="PriceBandTobeExcluded"
                          id={`PriceBandTobeExcluded${index}`}
                          value={priceBand.accountPriceListId}
                          onChange={(e) => handleOnChangeBand(index, e)}
                          checked={checkedBandState[index]}
                        />
                        <label htmlFor={`PriceBandTobeExcluded${index}`}>
                          {priceBand.accountPriceListId}{" "}
                        </label>
                      </div>
                    ))}
                  </div>
                  <br /> <br />
                  {/* Status Dropdown */}
                  <div className="input-field col-1">
                    <label className="full-width">{t("status_txt")}</label>
                    <select
                      className="col-4"
                      value={status}
                      onChange={(e) => setStatus(e.target.value)}
                    >
                      <option value="active">{t("active_txt")}</option>
                      <option value="inactive">{t("inactive_txt")}</option>
                    </select>
                  </div>
                  <button title={t("submit_txt")} type="submit">{t("submit_txt")}</button> &nbsp;&nbsp;
                  <button title={t("cancel_txt")} onClick={(e) => cancelbtn(e)}>{t("cancel_txt")}</button>
                </form>
              )}
            </div>
          </div>
        </section>
        <Footer />
      </div>
      {visibleAlert === true && (
        <div className="custom-alert-pop" style={{ display: "block" }}>
          <div className="custom-alert-container">
            <div className="custom-alert-wrap">
              <div className="custom-alert-header">
                <h4>{t("alert_txt")}</h4>
              </div>
              <div className="custom-alert-body">
                <p>{t("file_size_less_than_5mb_txt")}</p>
                <div className="alert-buttons">
                  <a onClick={popupClose} className="popup-alert-btn button">
                    {t("ok_txt")}
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </section>
  );
};
export default AddPromotions;
